import { render, staticRenderFns } from "./graph_x_axis.vue?vue&type=template&id=4a22fe6c&scoped=true&"
import script from "./graph_x_axis.vue?vue&type=script&lang=js&"
export * from "./graph_x_axis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22fe6c",
  null
  
)

export default component.exports